module.exports = __webpack_public_path__ + "img/paper.c0c21f73.png";